module.exports = __webpack_public_path__ + "img/sz.36aa99e6.svg";